module.exports = __webpack_public_path__ + "img/if_9.a31e970b.png";